(()=>{
  const INV=window.AXION_INVENTORY_SNAPSHOT;
  if(!INV)return;

  const scriptSrc=document.currentScript?.src||'';
  const themeAsset=name=>scriptSrc?new URL(name,scriptSrc).href:'';
  const TMR_IMG={
    Ginfull:'https://cdn.shopify.com/s/files/1/0772/4069/7083/files/axion-tmr-ginfull-gold.webp?v=1789560132',
    GuliKit:themeAsset('axion-tmr-gulikit-black-gold-v2.webp'),
    'K-Silver':'https://cdn.shopify.com/s/files/1/0772/4069/7083/files/axion-tmr-ksilver-gold.webp?v=1789560164'
  };
  const TMR_ALT={Ginfull:'Ginfull TMR',GuliKit:'GuliKit TMR','K-Silver':'K-Silver JS13PRO+ TMR'};

  const style=document.createElement('style');
  style.id='axion-v53-runtime-style';
  style.textContent=`
    .axv3 [data-action="tmr"]{position:relative;min-height:132px;padding-right:104px}
    .axv3 .axv3__tmr-icon{
      position:absolute;right:14px;top:50%;transform:translateY(-50%);
      width:78px;height:78px;object-fit:contain;border-radius:12px;
      background:#fff;padding:5px;border:1px solid rgba(255,255,255,.12);
      box-shadow:0 8px 24px rgba(0,0,0,.20);pointer-events:none
    }
    .axv3 .is-stock-soldout{cursor:not-allowed!important}
    .axv3 .is-stock-soldout:not(.is-selected){opacity:.48}
    .axv3 .is-stock-soldout.is-selected{opacity:.72}
    .axv3 .axv3__stock-card-badge{
      display:inline-flex;align-items:center;width:max-content;margin-top:8px;padding:5px 8px;
      border:1px solid rgba(255,76,89,.40);border-radius:999px;background:rgba(255,52,70,.10);
      color:#ff5c69;font-size:9px;line-height:1;font-weight:900;letter-spacing:.10em
    }
    .axv3 .axv3__swatch.is-stock-soldout{position:relative;opacity:.30!important}
    .axv3 .axv3__swatch.is-stock-soldout:before{
      content:'';position:absolute;left:5%;top:48%;width:90%;height:2px;background:#ff4354;
      transform:rotate(-45deg);border-radius:999px;pointer-events:none
    }
    .axv3 .axv3__stock-tooltip{
      display:none;position:absolute;left:50%;bottom:calc(100% + 8px);transform:translateX(-50%);
      z-index:20;padding:5px 7px;border-radius:6px;background:#111a27;border:1px solid rgba(255,76,89,.35);
      color:#ff6975;font-size:8px;line-height:1;font-weight:900;letter-spacing:.08em;white-space:nowrap;
      pointer-events:none
    }
    .axv3 .axv3__swatch.is-stock-soldout:hover .axv3__stock-tooltip,
    .axv3 .axv3__swatch.is-stock-soldout:focus-visible .axv3__stock-tooltip{display:block}
    @media(max-width:700px){
      .axv3 [data-action="tmr"]{min-height:118px;padding-right:88px}
      .axv3 .axv3__tmr-icon{width:64px;height:64px;right:10px}
    }
  `;
  document.getElementById(style.id)?.remove();
  document.head.appendChild(style);

  document.querySelectorAll('[data-axion-configurator]').forEach(root=>{
    const q=(s,p=root)=>p.querySelector(s);
    const qa=(s,p=root)=>[...p.querySelectorAll(s)];

    const isOut=qty=>Number(qty||0)<=0;

    const soldOut=(btn,out,mode='card')=>{
      if(!btn)return;
      const wasStockDisabled=btn.dataset.axionStockDisabled==='1';

      if(out){
        btn.classList.add('is-stock-soldout');
        btn.dataset.stockSoldout='1';
        btn.setAttribute('aria-disabled','true');
        if(!wasStockDisabled){
          btn.dataset.axionStockPrevDisabled=btn.disabled?'1':'0';
          btn.dataset.axionStockDisabled='1';
        }
        btn.disabled=true;

        if(mode==='swatch'){
          if(!btn.querySelector('.axv3__stock-tooltip')){
            const tip=document.createElement('span');
            tip.className='axv3__stock-tooltip';
            tip.textContent='ESAURITO';
            btn.appendChild(tip);
          }
          const base=(btn.getAttribute('aria-label')||btn.dataset.value||'').replace(/\s+—\s+ESAURITO$/,'');
          btn.setAttribute('aria-label',`${base} — ESAURITO`);
          btn.title='ESAURITO';
        }else if(!btn.querySelector('.axv3__stock-card-badge')){
          const badge=document.createElement('span');
          badge.className='axv3__stock-card-badge';
          badge.textContent='ESAURITO';
          btn.appendChild(badge);
        }
      }else{
        btn.classList.remove('is-stock-soldout');
        btn.dataset.stockSoldout='0';
        btn.removeAttribute('aria-disabled');
        btn.querySelector('.axv3__stock-card-badge')?.remove();
        btn.querySelector('.axv3__stock-tooltip')?.remove();
        if(btn.title==='ESAURITO')btn.removeAttribute('title');
        const label=btn.getAttribute('aria-label');
        if(label)btn.setAttribute('aria-label',label.replace(/\s+—\s+ESAURITO$/,''));
        if(wasStockDisabled){
          if(btn.dataset.axionStockPrevDisabled==='0')btn.disabled=false;
          delete btn.dataset.axionStockDisabled;
          delete btn.dataset.axionStockPrevDisabled;
        }
      }
    };

    const patchTmrIcons=()=>{
      qa('[data-action="tmr"]').forEach(btn=>{
        const key=btn.dataset.value;
        const src=TMR_IMG[key];
        if(!src)return;
        let img=btn.querySelector('.axv3__tmr-icon');
        if(!img){
          img=document.createElement('img');
          img.className='axv3__tmr-icon';
          img.loading='lazy';
          img.decoding='async';
          btn.appendChild(img);
        }
        if(img.src!==src)img.src=src;
        img.alt=TMR_ALT[key]||key;
      });
    };

    const applyPerformanceStock=()=>{
      qa('[data-action="tmr"]').forEach(btn=>soldOut(btn,isOut(INV.tmr?.[btn.dataset.value])));

      qa('[data-action="set"][data-key="btType"]').forEach(btn=>{
        let qty=0;
        if(btn.dataset.value==='Smart Bumpers L1–R1')qty=INV.shoulders?.bumpers;
        else if(btn.dataset.value==='Smart Triggers L2–R2')qty=INV.shoulders?.triggers;
        else if(btn.dataset.value==='Smart Bumpers & Triggers')qty=Math.min(Number(INV.shoulders?.bumpers||0),Number(INV.shoulders?.triggers||0));
        soldOut(btn,isOut(qty));
      });

      qa('[data-action="set"][data-key="smartFace"]').forEach(btn=>{
        if(btn.dataset.value==='Smart D-Pad & Face Buttons')soldOut(btn,isOut(INV.smartFront));
      });
    };

    const applyRearStock=()=>{
      const std=Number(INV.rearButtons?.Standard||0);
      const soft=Number(INV.rearButtons?.Soft||0);

      qa('[data-action="set"][data-key="rearCount"]').forEach(btn=>{
        const count=Number(btn.dataset.value||0);
        if(count===0)return soldOut(btn,false);
        soldOut(btn,Math.max(std,soft)<count);
      });

      const selectedCount=Number(q('[data-action="set"][data-key="rearCount"].is-selected')?.dataset.value||0);
      qa('[data-action="set"][data-key="rearType"]').forEach(btn=>{
        const qty=Number(INV.rearButtons?.[btn.dataset.value]||0);
        soldOut(btn,selectedCount>0&&qty<selectedCount);
      });

      qa('[data-action="rear-color"]').forEach(btn=>{
        if(selectedCount<=0)return soldOut(btn,false,'swatch');
        soldOut(btn,isOut(INV.rearCover?.[btn.dataset.value]),'swatch');
      });
    };

    const applyShellStock=()=>{
      qa('[data-action="shell"]').forEach(btn=>{
        soldOut(btn,isOut(INV.shells?.[btn.dataset.value]));
      });
    };

    const applyAestheticStock=()=>{
      qa('[data-action="a-color"]').forEach(btn=>{
        const group=INV.aesthetics?.[btn.dataset.key];
        if(!group)return;
        soldOut(btn,isOut(group[btn.dataset.value]),'swatch');
      });
    };

    const applyProductionStock=()=>{
      qa('[data-action="set"][data-key="leadTime"]').forEach(btn=>{
        if(btn.dataset.value==='Take Axion')soldOut(btn,isOut(INV.production?.['Take Axion']));
        else soldOut(btn,false);
      });
    };

    const polish=()=>{
      patchTmrIcons();
      applyPerformanceStock();
      applyRearStock();
      applyShellStock();
      applyAestheticStock();
      applyProductionStock();
      root.dataset.axionInventory='shopify-flow';
      root.dataset.axionInventorySyncedAt=INV.syncedAt||'';
    };

    root.addEventListener('click',e=>{
      const btn=e.target.closest('[data-stock-soldout="1"]');
      if(!btn)return;
      e.preventDefault();
      e.stopImmediatePropagation();
    },true);

    root.addEventListener('click',()=>queueMicrotask(polish));
    root.addEventListener('change',()=>queueMicrotask(polish));
    document.addEventListener('axion:inventory-updated',polish);
    polish();
  });
})();